import { createFileRoute } from "@tanstack/react-router";
import ShippingCredentials from "../../pages/admin/ShippingCredentials";

export const Route = createFileRoute("/admin/shipping-credentials")({
  component: ShippingCredentials,
});
